export const FirebaseConfig = {
	"projectId": "winggo-4fb4a",
	"appId": "1:722621686122:web:292fc23e45ea3925b84513",
	"databaseURL": "https://winggo-4fb4a-default-rtdb.firebaseio.com",
	"storageBucket": "winggo-4fb4a.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCqjdI9aPaiF3eEgAkmiZa2c9W9sNaV9v8",
	"authDomain": "winggo-4fb4a.firebaseapp.com",
	"messagingSenderId": "722621686122",
	"measurementId": "G-FN848KFTQG"
};